import { Skeleton } from '@mui/material';

import { useProjectSkeletonStyles } from './useProjectSkeletonStyles';

export const ProjectSkeleton = () => {
  const { classes } = useProjectSkeletonStyles();

  return (
    <div className={classes.root}>
      <div className={classes.left}>
        <Skeleton width={24} height={24} variant="rectangular" />
        <Skeleton width={120} height={24} variant="rectangular" />
      </div>
      <Skeleton width={32} height={32} variant="rectangular" />
    </div>
  );
};
